/**
 * Module dependencies.
 */

import { Container } from 'components/atoms/container/container';
import { Footer } from 'components/molecules/footer/footer';
import { JSX, useMemo } from 'react';
import { LocaleString } from 'types/locale-string';
import { MediaImage } from 'types/media';
import { PortfolioCategories } from 'components/molecules/portfolio-categories/portfolio-categories';
import { PortfolioHeader } from 'components/molecules/portfolio-header/portfolio-header';
import { PortfolioIntroduction } from 'components/molecules/portfolio-introduction/portfolio-introduction';
import { PortfolioSlideShow } from 'components/molecules/portfolio-slide-show/portfolio-slide-show';

/**
 * `Props` type.
 */

type Props = {
  portfolioCategory: Array<{
    description: LocaleString;
    id: number;
    images: Array<MediaImage>;
    title: LocaleString;
  }>;
};

/**
 * Export `Portfolio` component.
 */

export function Portfolio({ portfolioCategory }: Props): JSX.Element {
  const data = useMemo(() => {
    return portfolioCategory.filter((item) => {
      return item.images.length > 0;
    });
  }, [portfolioCategory]);

  return (
    <>
      <PortfolioHeader />

      <Container>
        <PortfolioIntroduction />

        <PortfolioCategories portfolioCategories={data}>
          {(data, currentCategory) => (
            <PortfolioSlideShow
              currentCategory={String(currentCategory)}
              data={data}
            />
          )}
        </PortfolioCategories>
      </Container>

      <Footer socialNetworks={{}} />
    </>
  );
}
